<template>
  <div>
    <p v-dompurify-html="message" class="auth-box__message" />

    <ElForm
      ref="registerForm"
      autocomplete="off"
      :model="registerFormModel"
      :rules="rules"
      @submit.native.prevent="submitRegisterForm"
    >
      <ElFormItem :label="$t('PASSWORD')" prop="password">
        <ElInput
          v-model="registerFormModel.password"
          type="password"
          dir="ltr"
          name="password"
          autocomplete="off"
        />
      </ElFormItem>

      <ElFormItem :label="$t('PASSWORD_CONFIRM')" prop="checkPass">
        <ElInput
          v-model="registerFormModel.checkPass"
          type="password"
          dir="ltr"
          name="checkPass"
          autocomplete="off"
        />
      </ElFormItem>

      <ElButton
        type="primary"
        class="auth-box__submit"
        native-type="submit"
        size="large"
        :loading="isSubmitting"
      >
        {{ $t('REGISTER_AGENT') }}
      </ElButton>

      <!-- dirty hack until ElementUI ends up with a solution -->
      <input v-show="false" type="submit" />
    </ElForm>
  </div>
</template>

<script>
import form from '@/mixins/form';
import passwordValidation from '@/mixins/passwordValidation';

import { Agents } from '@/api/api';

export default {
  name: 'RegisterAgentWithPassword',
  mixins: [form, passwordValidation],
  props: {
    publisherEmail: {
      type: String,
      default: '',
    },
    agentEmail: {
      type: String,
      default: '',
    },
    token: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isSubmitting: false,

      registerFormModel: {
        password: '',
        checkPass: '',
      },
    };
  },
  computed: {
    message() {
      if (!this.agentEmail || !this.publisherEmail) return '';
      return this.$t('REGISTER_AGENT.MESSAGE', {
        user_email: this.agentEmail,
        publisher_email: this.publisherEmail,
      });
    },
    rules() {
      return {
        password: this.basePasswordRules,
        checkPass: [
          ...this.basePasswordRules,
          {
            validator: this.checkPasswordConfirm('registerFormModel'),
            trigger: 'blur',
          },
        ],
      };
    },
  },
  methods: {
    submitRegisterForm() {
      if (!this.isValid('registerForm')) {
        return false;
      }

      this.isSubmitting = true;
      const { password, checkPass } = this.registerFormModel;
      return Agents.registerAgent(
        {},
        {
          token: this.token,
          password,
          password_confirm: checkPass,
        },
      )
        .then(({ body: { message, token } }) => {
          if (message) {
            this.$message.success(message);
          }
          this.$emit('success', token);
        })
        .catch(({ body: { message } }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
  },
};
</script>
